import React from 'react'
import 'react-multi-carousel/lib/styles.css'
import Carousel from 'react-multi-carousel'
import {Container, Row, Col} from 'react-bootstrap'
import colorSharp from '../assets/img/color-sharp.png'
// import { abouts } from '../constant'
import { AboutCard, CardSkeleton } from '../components'
import { getAbouts } from '../utils/groq'

const Skills = () => {
    const [abouts, setAbouts] = React.useState([])
    const [aboutsLoaded, setAboutsLoaded] = React.useState(false)

    React.useEffect(() => {
        getAbouts()
            .then(data => {
                setAbouts(data)
                setAboutsLoaded(true)
            })
    }, [])
    
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 4
        },
        desktop: {
            breakpoint: {max: 3000, min: 1024},
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: {max: 464, min: 0},
            items: 1
        }
    };

    return (
        <section className="skill" id="skills">
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx" data-zanim-xs='{"delay": 0.2,}' data-zanim-trigger="scroll" >
                            <div data-zanim-timeline='{}' data-zanim-trigger="scroll" >
                                <h2 data-zanim-xs='{"delay": 0.3}'>
                                    Je sais qu'un
                                    <span className="text-purple"> Bon Design </span> <br/>
                                    Signifie un <span className="text-purple"> Bon Business</span>
                                </h2>
                                <p data-zanim-xs='{"delay": 0.4}'>Grace à cette passion et au travail avec d'autres collaborateurs, j'ai pu développer un certain nombre de compétences.</p>
                                {aboutsLoaded && <Carousel
                                    responsive={responsive}
                                    infinite={true}
                                    // showDots={true}
                                    swipeable={true}
                                    itemClass="px-lg-4 px-md-2 px-1"
                                    className="skill-slider"
                                >
                                    {abouts.map((about, index) => {
                                        return <AboutCard
                                            key={about.title}
                                            animation={{
                                                "data-zanim-xs": `{"delay": 0.${ index + 5 }}`,
                                            }}
                                            {...about}
                                        />
                                    })}
                                </Carousel>}
                                { !aboutsLoaded && (
                                    <Row className="justify-content-center">
                                        <CardSkeleton cardsNumber={3} variant="about" />
                                    </Row>
                                ) }
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-left" src={colorSharp} alt="background canvas" />
        </section>
    )
}
export default Skills;